/**
 * @module "rule.util"
 */

define('formkit/rule.util',['require','exports','module','underscore','backbone','bluebird','uuid'],function(require, exports, module) {
  //prettier-ignore
  var _        = require('underscore'),
      Backbone = require('backbone'),
      Promise  = require('bluebird'),
      UUID     = require('uuid');

  /**
   * @class RuleUtil
   */

  var RuleUtil = {
    /**
     * @method insertRequiredRule - adds a new required rull to the templateObject
     * model
     *
     * @param  {Object} templateObjectModel
     */

    insertValidationRule: function(templateObjectModel, customValidationRule) {
      var defaultRule = {
        name: 'required_rule',
        action: 'validate',
        conditions: [
          {
            operation: 'filled',
          },
        ],
        hidden: true,
      };
      var ruleToInsert = customValidationRule ? customValidationRule : defaultRule;

      if (!templateObjectModel.get('rules')) {
        Promise.reject(new Error('Rules are not defined in your template object.'));
        return;
      }
      var ruleToRemove = templateObjectModel.get('rules').findWhere({ name: ruleToInsert.name });

      templateObjectModel.get('rules').remove(ruleToRemove);

      if (templateObjectModel.get('required')) {
        templateObjectModel.get('rules').add(ruleToInsert);
      }
    },

    /**
     * @method insertRequiredRule
     *
     * @deprecated since v1.6.1
     * @description alias for insertValidationRule, and provided for legacy support
    **/

    insertRequiredRule: function() {
      this.insertValidationRule.apply(this, arguments);
    },

    /**
     * @method eachRule
     *
     * @param   {Object}      templateObjectModel
     * @param   {Function}    fn
     * @param   {List}        context
     * @param   {Object}      options
     * @returns {undefined}   Break out of function on error or if the model doesn't
     * have any rules
     */

    eachRule: function(templateObjectModel, fn, context, options) {
      if (!(templateObjectModel instanceof Backbone.Model)) {
        Promise.reject(new Error('templateObjectModel argument must be a Backbone.Model'));
        return;
      }

      options || (options = {});

      if (!templateObjectModel.get('rules')) {
        return;
      }

      templateObjectModel.get('rules').each(function(rule) {
        fn.call(context, rule);
      });
    },

    /**
     * @method eachCondition
     *
     * @param   {Object}    ruleModel
     * @param   {Function}  fn
     * @param   {List}      context
     * @param   {Object}    options
     * @returns {undefined} Break out of function on error or if the model doesn't
     * have any conditions
     */

    eachCondition: function(ruleModel, fn, context, options) {
      if (!(ruleModel instanceof Backbone.Model)) {
        Promise.reject(new Error('ruleModel argument must be a Backbone.Model'));
        return;
      }

      options || (options = {});

      if (!ruleModel.get('conditions')) {
        return;
      }

      ruleModel.get('conditions').each(function(condition) {
        fn.call(context, condition);
      });
    },

    /**
     * @method ruleHasConditions
     *
     * @param  {Object}   ruleModel
     * @returns {boolean} If a rule has any conditions return true.
     */

    ruleHasConditions: function(ruleModel) {
      if (!(ruleModel instanceof Backbone.Model)) {
        Promise.reject(new Error('ruleModel argument must be a Backbone.Model'));
        return;
      }
      var conditionCollection = ruleModel.get('conditions');

      return !!(conditionCollection && conditionCollection.length > 0);
    },

    /**
     * @method insertRule
     *
     * @param   {Onject}    templateObjectModel
     * @param   {Object}    rule   Rule to add
     * @returns {undefined} Break out of function on error
     */

    insertRule: function(templateObjectModel, rule) {
      if (!(templateObjectModel instanceof Backbone.Model)) {
        Promise.reject(new Error('templateObjectModel argument must be a Backbone.Model'));
        return;
      }

      return templateObjectModel.get('rules').add(rule);
    },

    /**
     * @method removeRule
     *
     * @param   {Object}    ruleModel
     * @returns {undefined} Break out of function on error
     */

    removeRule: function(ruleModel) {
      if (!(ruleModel instanceof Backbone.Model)) {
        Promise.reject(new Error('ruleModel argument must be a Backbone.Model'));
        return;
      }

      if (ruleModel.collection) {
        ruleModel.collection.remove(ruleModel);
      }
    },

    /**
     * @method insertCondition
     *
     * @param   {Object} ruleModel
     * @param   {Object} condition
     * @returns {Object} ruleModel with the added condition
     */

    insertCondition: function(ruleModel, condition) {
      if (!(ruleModel instanceof Backbone.Model)) {
        Promise.reject(new Error('ruleModel argument must be a Backbone.Model'));
        return;
      }

      return ruleModel.get('conditions').add(condition);
    },

    /**
     * @method removeCondition
     *
     * @param  {Object} conditionModel
     */

    removeCondition: function(conditionModel) {
      if (!(conditionModel instanceof Backbone.Model)) {
        Promise.reject(new Error('conditionModel argument must be a Backbone.Model'));
        return;
      }

      if (conditionModel.collection) {
        conditionModel.collection.remove(conditionModel);
      }
    },
  };

  module.exports = RuleUtil;
});

